import { render, staticRenderFns } from "./LegacyTableDropDownComponent.vue?vue&type=template&id=c81a0e94&"
import script from "./LegacyTableDropDownComponent.vue?vue&type=script&lang=ts&"
export * from "./LegacyTableDropDownComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c81a0e94')) {
      api.createRecord('c81a0e94', component.options)
    } else {
      api.reload('c81a0e94', component.options)
    }
    module.hot.accept("./LegacyTableDropDownComponent.vue?vue&type=template&id=c81a0e94&", function () {
      api.rerender('c81a0e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/models/Table/Legacy/Elements/LegacyTableDropDownComponent.vue"
export default component.exports